module.exports = __webpack_public_path__ + "images/e1e5cbeb6646206cb524a6a47772970a-level2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/level2.png
// module id = 1025
// module chunks = 0